import { createContext, useContext, useState } from "react";
import { StudyCapture } from "maven-lib/dist/dto/entity";
import { uniqWith } from "lodash";

export interface EcoaStudyCapture extends Omit<StudyCapture, "id" | "freshman" | "deleted" | "itemId"> {
  id: bigint | null;
  itemId: string | null;
  freshman: boolean | null;
  deleted: boolean | null;
}

interface CaptureContextProps {
  captures: EcoaStudyCapture[];
  setCaptures: (captures: EcoaStudyCapture[]) => void;
}

const CaptureContext = createContext<CaptureContextProps>({
  captures: [],
  setCaptures: () => {},
});

function CaptureContextProvider(props: { children: React.ReactNode }) {
  const [captures, setCapturesState] = useState<EcoaStudyCapture[]>([]);

  const setCaptures = (captureDatas: EcoaStudyCapture[]) => {
    setCapturesState((prev) =>
      uniqWith(
        [...captureDatas, ...prev],
        (a, b) =>
          a.groupId === b.groupId &&
          a.folderId === b.folderId &&
          a.visitId === b.visitId &&
          a.visitSeq === b.visitSeq &&
          a.crfPageId === b.crfPageId &&
          a.crfPageSeq === b.crfPageSeq &&
          a.itemId === b.itemId &&
          a.itemSeq === b.itemSeq
      )
    );
  };

  return <CaptureContext.Provider value={{ captures, setCaptures }}>{props.children}</CaptureContext.Provider>;
}

function useCaptureContext() {
  return useContext(CaptureContext);
}

export { CaptureContext, CaptureContextProvider, useCaptureContext };
